import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '../../i18n/locale-context.js';
const FORMATS = [
    {
        kind: 'fhir-bundle',
        labelKey: 'export.format.fhir_bundle.label',
        descriptionKey: 'export.format.fhir_bundle.description',
    },
    {
        kind: 'fhir-audit-event-bundle',
        labelKey: 'export.format.fhir_audit_event_bundle.label',
        descriptionKey: 'export.format.fhir_audit_event_bundle.description',
    },
    {
        kind: 'structured-json',
        labelKey: 'export.format.structured_json.label',
        descriptionKey: 'export.format.structured_json.description',
    },
    {
        kind: 'original-holder-format',
        labelKey: 'export.format.original_holder_format.label',
        descriptionKey: 'export.format.original_holder_format.description',
    },
];
export function ExportFormatStep(props) {
    const { t } = useLocale();
    return (_jsxs("section", { "aria-labelledby": "format-heading", children: [_jsx("h3", { id: "format-heading", children: t('export.format.heading') }), _jsx("p", { children: t('export.format.body') }), _jsx("ul", { "aria-label": t('export.format.formats_aria_label'), children: FORMATS.map((f) => (_jsxs("li", { children: [_jsx("button", { type: "button", onClick: () => props.onSelectFormat(f.kind), children: t(f.labelKey) }), _jsxs("span", { children: [" \u2014 ", t(f.descriptionKey)] })] }, f.kind))) }), _jsx("button", { type: "button", onClick: props.onCancel, children: t('export.format.cancel') })] }));
}
//# sourceMappingURL=format-step.js.map